export const FETCH_FILE_STATUS_REQUEST = "FETCH_FILE_STATUS_REQUEST";
export const FETCH_FILE_STATUS_SUCCESS = "FETCH_FILE_STATUS_SUCCESS";
export const FETCH_FILE_STATUS_FAILURE = "FETCH_FILE_STATUS_FAILURE";
export const FETCH_FILE_STATUS_RESET = "FETCH_FILE_STATUS_RESET";
export const fetchFileStatusRequest = (payload) => ({
    type: FETCH_FILE_STATUS_REQUEST,
    payload,
});
export const fetchFileStatusSuccess = (payload) => ({
    type: FETCH_FILE_STATUS_SUCCESS,
    payload,
});
export const fetchFileStatusFailure = (payload) => ({
    type: FETCH_FILE_STATUS_FAILURE,
    payload,
});
export const fetchFileStatusReset = () => ({
    type: FETCH_FILE_STATUS_RESET,
});
